import * as Yup from "yup";

export const sectionSchema = Yup.object({
  section_name: Yup.string().required("Section Name is required"),
});
